import { RadioProps } from "@chakra-ui/react";
import React, { useMemo } from "react";
import ReactSelect from "react-select";

import { FormControlQuestionSearch } from "../../../molecules/FormControl/FormControlQuestionSearch";

interface IProps extends RadioProps {
  options: {
    name: string;
    value: string;
  }[];
  label: string;
  name: string;
  setValue: (value: string) => void;
}

export function ReactSelectQuestion({
  options,
  label,
  name,
  setValue,
}: IProps) {
  const sortedOptions = useMemo(() => {
    return options
      .map((opt) => ({ label: opt.name, value: opt.value }))
      .sort((a, b) =>
        (a.label ?? "").localeCompare(b.label ?? "", "pt-BR", {
          sensitivity: "base",
        })
      );
  }, [options]);

  return (
    <FormControlQuestionSearch isRequired label={label} name={name}>
      <ReactSelect
        placeholder="Selecione uma unidade"
        classNamePrefix="select"
        isSearchable
        isClearable
        name={name}
        options={sortedOptions}
        onChange={(e) => {
          if (e) setValue(e.value);
        }}
      />
    </FormControlQuestionSearch>
  );
}
